export enum AnnouncementLevel {
  Info = 'Info',
  Advisory = 'Advisory',
  Important = 'Important',
  Critical = 'Critical'
}

export interface IAnnouncement {
  id: string;
  title: string;
  body: string;
  language: string;
  level: AnnouncementLevel;
  active: boolean;
  isPopup: boolean;
  imageUrl?: string;
  createdAt: string;
  updatedAt: string;
}

export interface IAnnouncementListing {
  id: string;
  title: string;
  body: string;
  language: string;
  level: AnnouncementLevel;
  active: boolean;
  status: string;
}

export interface ICreateAnnouncementModel {
  title: string;
  body: string;
  language: string;
  level?: AnnouncementLevel | string;
  isPopup?: boolean;
  image?: File;
}

export interface IUpdateAnnouncementModel {
  id: string;
  title?: string;
  body?: string;
  language?: string;
  level?: AnnouncementLevel | string;
  isPopup?: boolean;
  image?: File;
  imageUrl?: string;
}

export interface ICreateAttachmentModel {
  entityType: string;
  entityId: string;
  file: File;
}

export interface ICreateBulkAttachmentsModel {
  entityType: string;
  entityId: string;
  files: File[];
}
